module.exports = __webpack_public_path__ + "static/media/vitamins.4781af0d.svg";